
/* фикс UTF-8 */

const defaultOptions = {
  name: 'arm-modal',
  classNames: ['arm-modal'],
  size: 'md',
  closeButtonContent: '<svg class="arm-modal__close-icon"><use xlink:href="#icon-cancel"/></svg>'
};

const ArmModalComponent = {
  template:
    `<div>
      <div class="arm-modal__content">
        <slot></slot>
      </div>
      <div
        class="arm-modal__buttons"
        v-if="buttons.length > 0">
        <button
          v-for="(button, i) in buttons"
          class="button-default"
          :class="button.mod ? 'button-default_' + button.mod : ''"
          type="button"
          :key="i"
          v-html="button.title"
          @click.stop="click(i, $event)">
          {{button.title}}
        </button>
      </div>
      <div class="arm-modal__loader"></div>
    </div>`,
  props: {
    buttons: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    click (i, event, source = 'click') {
      const button = this.buttons[i];

      if (button && typeof button.handler === 'function') {
        button.handler(i, event, { source });
      } else {
        this.$emit('modals:close');
      }
    }
  }
};

function armModalOpen(modalOptions = {}, modalClass = '') {
  let options = JSON.parse(JSON.stringify(defaultOptions));

  if (modalClass) {
    options.classNames.push(modalClass);
  }

  VueModal.Bus.$emit(
    'new',
    Object.assign(
      {},
      options,
      modalOptions
    )
  );
}

export { ArmModalComponent, armModalOpen };